// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import {
  PostOrPatchServiceUserDto,
  ZitadelServiceUser,
} from "@src/types/user-management";
import { buildRequestObjectForServiceUser } from "@src/cloud-connect/user-manager/utils/build-request-service-user-object";

export const postCreateServiceUser = async (
  namespace: string,
  user: Partial<ZitadelServiceUser>,
) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  const toBeCreatedServiceUserObject: PostOrPatchServiceUserDto =
    buildRequestObjectForServiceUser(user);

  try {
    const response = await axios.post<ZitadelServiceUser>(
      `${url}/api/v1/ns/${namespace}/users/service-api`,
      toBeCreatedServiceUserObject,
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while creating service user.",
      );
    }
  }
};
